import { logoutUser } from "../../api/services/LoginServices";
import {
  showErrorNotification,
  showSuccessNotification,
} from "../../customHooks";
import * as actionTypes from "../actionsTypes/Types";

export const loginAction = (type, payload) => {
  return sendToReducer(type, payload);
};
function sendToReducer(type, payload) {
  if (type === "LOGIN_SUCCESS") {
    showSuccessNotification("Login Successfully");
  }
  return {
    type: type,
    payload: payload,
  };
}
export const logoutAction = () => {
  logoutUser();
  return {
    type: actionTypes.LOGOUT,
  };
};
